export const comments_4987549 = {"data":{"data":[],"links":{}}}